import { useState, useCallback } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryTabs from "./components/CategoryTabs";
import RankingList from "./components/RankingList";
import FeaturedGrid from "./components/FeaturedGrid";
import NewsletterSection from "./components/NewsletterSection";

export default function Home() {
  const [activeCategory, setActiveCategory] = useState("");

  const handleCategoryChange = useCallback((slug: string) => {
    setActiveCategory(slug);
    const rankingEl = document.getElementById("ranking");
    if (rankingEl) {
      rankingEl.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              name: "po18脸红心跳",
              url: "https://po18-faceheart.com",
              description: "po18脸红心跳是深受读者喜爱的言情小说平台内容标签，汇聚大量让人脸红心跳的甜宠、虐恋、霸总等热门故事。",
              potentialAction: {
                "@type": "SearchAction",
                target: "https://po18-faceheart.com/search?q={search_term_string}",
                "query-input": "required name=search_term_string",
              },
            }),
          }}
        />
        <HeroSection />
        <CategoryTabs
          activeCategory={activeCategory}
          onCategoryChange={handleCategoryChange}
        />
        <RankingList activeCategory={activeCategory} />
        <FeaturedGrid />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}